import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class SocialNetworksAPI extends ComponentAPI {
    getFacebook() {
        return this.state.facebook;
    }
    setFacebook(facebook) {
        this.setState({ facebook });
    }
    getInstagram() {
        return this.state.instagram;
    }
    setInstagram(instagram) {
        this.setState({ instagram });
    }
    getLinkedin() {
        return this.state.linkedin;
    }
    setLinkedin(linkedin) {
        this.setState({ linkedin });
    }
    getTwitter() {
        return this.state.twitter;
    }
    setTwitter(twitter) {
        this.setState({ twitter });
    }
    getYoutube() {
        return this.state.youtube;
    }
    setYoutube(youtube) {
        this.setState({ youtube });
    }
}
export default SocialNetworksAPI;
//# sourceMappingURL=social-networks-api.js.map